
/* global ga */
import Vue from 'vue';
import Router from 'vue-router';
import navGuard from '@/utils/navGuard';

import Dashboard from '@/components/Dashboard';
import Submission from '@/components/Submission';
import Signup from '@/components/Profile/Signup';
import PageNotFound from '@/components/PageNotFound';
import FrequentlyAskedQuestion from '@/router/routes/faq';

import store from '@/store';

const Login = () => import('@/components/Login');
const Profile = () => import('@/components/Profile');
const FastTrack = () => import('@/components/Licenses/FilmLicenseAgreementFastTrack');
const SeriesFastTrack =() => import('@/components/Licenses/FilmLicenseAgreementFastTrack/SeriesFastTrack');
Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'Dashboard' },
    },
    ...Dashboard,
    ...Submission,
    { path: '/profile',
      name: 'Profile',
      component: Profile,
    }, {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        fullscreen: true,
      },
    },
    ...Signup,
    ...FrequentlyAskedQuestion,
    {
      path: '/film-license',
      name: 'FastTrack',
      component: FastTrack,
      meta: {
        guest: true,
        fullscreen: true,
      },
    },
    {
      path: '/series-license',
      name: 'SeriesFastTrack',
      component: SeriesFastTrack,
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        guest: true,
        fullscreen: true,
      },
    },
  ],
});

const handleFullscreen = function handleFullscreen(to, incomingRoute) {
  if (to.meta.fullscreen) {
    store.commit('layout/update', {
      aside: false,
      header: false,
      main: true,
      footer: false,
    });
  } else {
    store.commit('layout/update', {
      aside: true,
      header: true,
      main: true,
      footer: true,
    });
  }
};

router.beforeEach((to, from, next) => {
  const windowPathName = window.location.pathname;
  if (windowPathName !== '/' && typeof history !== 'undefined') {
    history.replaceState(null, '', '/#/');
    next(windowPathName);
    return;
  }

  if (to.path) {
    ga('set', 'page', to.path);
    ga('send', 'pageview');
  }

  if (!navigator.onLine && from.fullPath !== '/') {
    // TODO: Ajax request also need this functionality. Consider making this
    //       offline notifier as a module
    // Note: $notify module should have already been loaded at this point
    if (Vue.prototype.$notify) {
      Vue.prototype.$notify.warning({
        title: 'Warning',
        message: 'There is no Internet connection',
      });
    } else {
      // Fallback to alert in unexpected circumstances
      /* eslint no-alert: 0 */
      alert('Warning, there is no Internet connection');
    }
  }

  navGuard(to, (incomingRoute) => {
    if (incomingRoute === undefined) {
      handleFullscreen(to);
    }
    next(incomingRoute);
  });
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js